import { Subject } from 'rxjs/Subject';
/**
 * @hidden
 */
var NavigationCursor = /** @class */ (function () {
    function NavigationCursor(model) {
        this.model = model;
        this.changes = new Subject();
        this.activeRow = 0;
        this.activeCol = 0;
        this.virtualCol = 0;
        this.virtualRow = 0;
    }
    Object.defineProperty(NavigationCursor.prototype, "row", {
        get: function () {
            return this.model.findRowByIndex(this.activeRow);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavigationCursor.prototype, "cell", {
        get: function () {
            var _this = this;
            var row = this.row;
            if (row) {
                return row.cells.find(function (c) { return c.colIndex === _this.activeCol; });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavigationCursor.prototype, "dataRowIndex", {
        get: function () {
            var row = this.row;
            if (row) {
                return row.dataRowIndex;
            }
            return -1;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Assumes and announces a new cursor position.
     */
    NavigationCursor.prototype.reset = function (rowIndex, colIndex) {
        if (rowIndex === void 0) { rowIndex = this.activeRow; }
        if (colIndex === void 0) { colIndex = this.activeCol; }
        this.virtualRow = rowIndex;
        this.virtualCol = colIndex;
        this.activate(rowIndex, colIndex, { force: true });
    };
    /**
     * Assumes a new cursor position without announcing it.
     */
    NavigationCursor.prototype.assume = function (rowIndex, colIndex) {
        if (rowIndex === void 0) { rowIndex = this.activeRow; }
        if (colIndex === void 0) { colIndex = this.activeCol; }
        this.virtualRow = rowIndex;
        this.virtualCol = colIndex;
        this.activeCol = colIndex;
        this.activeRow = rowIndex;
    };
    /**
     * Announces a current cursor position to subscribers.
     */
    NavigationCursor.prototype.announce = function () {
        this.changes.next({
            colIndex: this.activeCol,
            prevColIndex: this.activeCol,
            prevRowIndex: this.activeRow,
            rowIndex: this.activeRow
        });
    };
    NavigationCursor.prototype.isActive = function (rowIndex, colIndex) {
        return this.activeCol === colIndex && this.activeRow === rowIndex;
    };
    NavigationCursor.prototype.moveUp = function (offset) {
        if (offset === void 0) { offset = 1; }
        return this.offsetRow(-offset);
    };
    NavigationCursor.prototype.moveDown = function (offset) {
        if (offset === void 0) { offset = 1; }
        return this.offsetRow(offset);
    };
    NavigationCursor.prototype.moveLeft = function (offset) {
        if (offset === void 0) { offset = 1; }
        return this.offsetCol(-offset);
    };
    NavigationCursor.prototype.moveRight = function (offset) {
        if (offset === void 0) { offset = 1; }
        return this.offsetCol(offset);
    };
    NavigationCursor.prototype.offsetCol = function (offset) {
        var _this = this;
        var prevRow = this.model.findRowByIndex(this.virtualRow);
        this.virtualCol = Math.max(0, Math.min(this.virtualCol + offset, prevRow.cells.length - 1));
        var nextColIndex = this.virtualCol;
        var nextRowIndex = this.virtualRow;
        var cell = prevRow.cells.find(function (c) { return c.colIndex === _this.virtualCol; });
        var parentCell = cell.parent;
        if (parentCell === this.cell) {
            if (offset < 0) {
                nextColIndex = parentCell.colIndex - 1;
            }
            else {
                nextColIndex = parentCell.colIndex + parentCell.colSpan;
            }
            this.virtualCol = Math.max(0, Math.min(nextColIndex, prevRow.cells.length - 1));
        }
        cell = prevRow.cells.find(function (c) { return c.colIndex === _this.virtualCol; });
        if (cell.parent) {
            nextColIndex = cell.parent.colIndex;
            nextRowIndex = cell.parent.rowIndex;
        }
        var nextRow = this.model.findRowByIndex(nextRowIndex);
        nextColIndex = Math.max(0, Math.min(nextColIndex, nextRow.cells.length - 1));
        return this.activate(nextRowIndex, nextColIndex);
    };
    NavigationCursor.prototype.offsetRow = function (offset) {
        var _this = this;
        if (this.metadata && this.metadata.isVirtual) {
            var maxIndex = this.metadata.maxLogicalRowIndex;
            var nextIndex = Math.max(0, Math.min(this.activeRow + offset, maxIndex));
            this.virtualRow = nextIndex;
            return this.activate(nextIndex, this.activeCol);
        }
        var prevRow = this.model.findRowByIndex(this.virtualRow);
        var prevPos = this.model.rowPosition(prevRow);
        var nextPos = prevPos + offset;
        var nextRow = this.model.findRowByPosition(nextPos);
        if (nextRow === prevRow) {
            return false;
        }
        var cell = nextRow.cells.find(function (c) { return c.colIndex === _this.virtualCol; }) || nextRow.cells[0];
        this.virtualRow = nextRow.index;
        var nextColIndex = this.virtualCol;
        if (cell.parent) {
            if (cell.parent === this.cell) {
                var parentRow = this.model.findRowByIndex(cell.parent.rowIndex);
                var parentPos = this.model.rowPosition(parentRow);
                if (offset < 0) {
                    nextPos = parentPos - 1;
                }
                else {
                    nextPos = prevPos + cell.parent.rowSpan;
                }
                nextRow = this.model.findRowByPosition(nextPos);
            }
            else {
                nextColIndex = cell.parent.colIndex;
                nextRow = this.model.findRowByIndex(cell.parent.rowIndex);
            }
            this.virtualRow = nextRow.index;
        }
        return this.activate(nextRow.index, nextColIndex);
    };
    // tslint:disable-next-line typedef
    NavigationCursor.prototype.activate = function (rowIndex, colIndex, _a) {
        var force = (_a === void 0 ? { force: false } : _a).force;
        if (!force && this.isActive(rowIndex, colIndex)) {
            return false;
        }
        var prevColIndex = this.activeCol;
        var prevRowIndex = this.activeRow;
        this.activeCol = colIndex;
        this.activeRow = rowIndex;
        this.changes.next({
            colIndex: colIndex,
            prevColIndex: prevColIndex,
            prevRowIndex: prevRowIndex,
            rowIndex: rowIndex
        });
        return true;
    };
    return NavigationCursor;
}());
export { NavigationCursor };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-grid/dist/es/navigation/navigation-cursor.js
// module id = ../../../../@progress/kendo-angular-grid/dist/es/navigation/navigation-cursor.js
// module chunks = vendor